import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-trending-up",
  templateUrl: "./med-icon-trending-up.component.html",
})
export class MedIconTrendingUpComponent extends SvgMixinComponent {}
